// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"84":"31a21bb3c65e1072","137":"197334ed97c22c24"}[chunkId] + ".css";
};